import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks'
import { PrinterIcon } from '../../../../ui/icons/PrinterIcon'
import { TrashIcon } from '../../../../ui/icons/trash'
import { UploadIcon } from '../../../../ui/icons/uploadIcon'
import Button from '../../../../ui/molecules/button'
import { Calendar } from '../../../../ui/molecules/calendar'
import { FileInputComponent } from '../../../../ui/molecules/fileInput'
import { FileViewer } from '../../../../ui/molecules/fileViewer'
import { SelectCustom } from '../../../../ui/molecules/select'
import '../../styles.scss'
import { GetAllNotification, resetGetAllNotificationStatus } from '../../slice'
import { formatterDate, OptionType, ParcelMethodOptions } from '../../../../utils'
import { CopyParcelFromNotification, ExportCompleteNotification, ExportCurrentAndPreviousNotifications, setAllParcelMethods, setAllParcelStartingAndEndingDate, setEndingDateForAll, setEndingDateOnlyConversion, setMethodToUpdate, setNotificationIdToCopy, setNotificationIdToExport, setOnlyConversionParcelStartingAndEndingDate, setStartingDateForAll, setStartingDateOnlyConversion, setUpdateFromCsvFile, UpdateParcelsFromCsv } from './slice'

export function ParticelleTools() {
    const sessionState = useAppSelector(state => state.session)
    const dispatch = useAppDispatch()
    const notificationState = useAppSelector(state => state.notification)
    const parcelState = useAppSelector(state => state.parcel)
    const [notificationOptions, setNotificationOptions] = useState<OptionType[]>([])

    let formData = new FormData()

    useEffect(() => {
        dispatch(GetAllNotification({
            itemsPerPage: 0,
            page: 0,
            customerId: sessionState.selected.customerId!
        }))
    }, [])

    useEffect(() => {
        if (notificationState.getAllNotificationStatus === 'successfully' &&
            notificationState.getAllNotificationResponse !== undefined
        ) {
            dispatch(resetGetAllNotificationStatus())

            const data = notificationState.getAllNotificationResponse.data.map(n => {
                return {
                    value: n.id,
                    label: `${n.notificationProtocolInfo} del ${formatterDate(n.releaseDate)}`
                } as OptionType
            })

            setNotificationOptions(data)
        }
    }, [notificationState.getAllNotificationStatus])

    useEffect(() => {
        if (parcelState.updateParcelsFromCsvStatus === 'successfully') {
            dispatch(setUpdateFromCsvFile(null))
        }
    }, [parcelState.updateParcelsFromCsvStatus])

    const handleUpdateFromCsv = () => {
        formData.delete('file')
        formData.append('file', parcelState.updateFromCsvFile!)
        dispatch(UpdateParcelsFromCsv(formData))
    }

    return (
        <div>
            <div className='pb-5'>
                <div className="notify-text-bold text-left">
                    Copia i campi da
                </div>
                <div style={{ display: 'flex', gap: '24px', alignItems: 'flex-end' }}>
                    <div style={{ flex: 1 }}>
                        <SelectCustom
                            options={notificationOptions}
                            placeholder='Seleziona notifica...'
                            onChange={(value) => dispatch(setNotificationIdToCopy(value))}
                        />
                    </div>
                    <div className='pb-[2px]'>
                        <Button
                            disabled={parcelState.notificationIdToCopy === ''}
                            variant='solid'
                            color='orange'
                            iconPosition='off'
                            size='md'
                            label='Copia'
                            onClick={() => dispatch(CopyParcelFromNotification({ prevNotId: notificationState.notificationIdToUpdate, currNotId: parcelState.notificationIdToCopy }))}
                        />
                    </div>
                </div>
            </div>

            <div className='pb-5'>
                <div className="notify-text-bold text-left">
                    Esporta CSV della notifica selezionata
                </div>
                <div style={{ paddingBottom: '10px', display: 'flex', gap: '24px', alignItems: 'flex-end' }}>
                    <SelectCustom
                        options={notificationOptions}
                        placeholder='Seleziona notifica...'
                        onChange={(value) => dispatch(setNotificationIdToExport(value))}
                    />
                    <div className='mb-1'>
                        <Button
                            disabled={parcelState.notificationIdToExport === ''}
                            variant='outline'
                            color='dimgrey'
                            size='md'
                            iconPosition='only'
                            icon={<PrinterIcon color='#74A4A9' />}
                            onClick={() => dispatch(ExportCurrentAndPreviousNotifications({ prevNotId: parcelState.notificationIdToExport, currNotId: notificationState.notificationIdToUpdate }))}
                        />
                    </div>
                    <div className='mb-1'>
                        <Button
                            variant='solid'
                            color='dimgrey'
                            size='md'
                            iconPosition='left'
                            label='Esporta CSV notifica attuale'
                            icon={<PrinterIcon color='#fff' />}
                            onClick={() => dispatch(ExportCurrentAndPreviousNotifications({ currNotId: notificationState.notificationIdToUpdate }))}
                        />
                    </div>
                </div>
            </div>

            <div className='pb-5' style={{ display: 'flex', gap: '24px', borderBottom: '1px solid #74A4A9' }}>
                <div className='pr-5' style={{ flex: '0.5', borderRight: '1px solid #74A4A9' }}>
                    <div className="notify-text-bold text-left pb-2">
                        Aggiorna particellare da csv
                    </div>
                    <div>
                        <FileInputComponent
                            id={"particle-upload-add"}
                            key={"particle-upload-add"}
                            color={"green"}
                            onChange={(e) => {
                                dispatch(setUpdateFromCsvFile(e[0]))
                            }}
                        />
                        {
                            parcelState.updateFromCsvFile && (
                                <div className="pt-3" style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                                    <FileViewer
                                        toUpdate
                                        fileName={parcelState.updateFromCsvFile.name}
                                        otherInfo={parcelState.updateFromCsvFile.type}
                                    />
                                    <button style={{ display: 'flex', justifyContent: 'center' }} onClick={() => dispatch(setUpdateFromCsvFile(null))}>
                                        <TrashIcon size={20} color="dimgrey" />
                                    </button>
                                    <button style={{ display: 'flex', justifyContent: 'center' }} onClick={() => handleUpdateFromCsv()}>
                                        <UploadIcon />
                                    </button>
                                </div>
                            )
                        }
                    </div>
                </div>

                <div style={{ flex: '0.5' }}>
                    <div className="notify-text-bold text-left pb-2">
                        Aggiorna particellare da csv formato sian (dati catastali uniti)
                    </div>
                    <div>
                        <FileInputComponent
                            id={"particle-upload-add"}
                            key={"particle-upload-add"}
                            color={"green"}
                            onChange={(e) => {

                            }}
                        />
                        {
                            true && ( // TO CHANGE WITH SAVED FILE
                                <div className="pt-3" style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                                    <FileViewer
                                        toUpdate
                                        fileName={'Name'}
                                        otherInfo={'Info'}
                                    />
                                    <button style={{ display: 'flex', justifyContent: 'center' }} onClick={() => {/* SET UNDEFINED */ }}>
                                        <TrashIcon size={20} color="dimgrey" />
                                    </button>
                                    <button style={{ display: 'flex', justifyContent: 'center' }} onClick={() => {/*  */ }}>
                                        <UploadIcon />
                                    </button>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>

            <div className='pb-5 pt-5'>
                <div className="notify-text-bold text-left pb-2">
                    Applica lo stesso metodo a tutte le particelle
                </div>

                <div style={{ display: 'flex', gap: '24px', alignItems: 'flex-end' }}>
                    <SelectCustom
                        disabled={!parcelState.onEdit}
                        options={ParcelMethodOptions}
                        placeholder='Seleziona metodo...'
                        onChange={(value) => dispatch(setMethodToUpdate(value))}
                    />
                    <div className='pb-[2px]'>
                        <Button
                            disabled={parcelState.methodToUpdate === undefined}
                            variant='solid'
                            color='dimgrey'
                            size='md'
                            iconPosition='off'
                            label='Applica'
                            onClick={() => dispatch(setAllParcelMethods(parcelState.methodToUpdate))}
                        />
                    </div>
                </div>
            </div>

            <div className='pb-5 pt-5'>
                <div className="notify-text-bold text-left pb-1">
                    Assegna le date di inizio e fine conversione (solo per metodo "Conversione")
                </div>

                <div style={{ display: 'flex', gap: '24px', alignItems: 'flex-end' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className="text-left">
                            <span className="input-label">Data inizio conversione  </span>
                        </div>
                        <Calendar
                            disabled={!parcelState.onEdit}
                            selected={parcelState.startingDateOnlyConversion}
                            onChange={(date) => dispatch(setStartingDateOnlyConversion(date))}
                            onClear={(date) => dispatch(setStartingDateOnlyConversion(null))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className="text-left">
                            <span className="input-label">Data fine conversione  </span>
                        </div>
                        <Calendar
                            disabled={!parcelState.onEdit}
                            selected={parcelState.endingDateOnlyConversion}
                            onChange={(date) => dispatch(setEndingDateOnlyConversion(date))}
                            onClear={(date) => dispatch(setEndingDateOnlyConversion(date))}
                        />
                    </div>
                    <div className='pb-[2px]'>
                        <Button
                            disabled={parcelState.startingDateOnlyConversion === undefined && parcelState.endingDateOnlyConversion === undefined}
                            variant='solid'
                            color='dimgrey'
                            size='md'
                            iconPosition='off'
                            label='Assegna'
                            onClick={() => dispatch(setOnlyConversionParcelStartingAndEndingDate({
                                startingDate: parcelState.startingDateOnlyConversion,
                                endingDate: parcelState.endingDateOnlyConversion
                            }))}
                        />
                    </div>
                </div>
            </div>

            <div className='pb-5 pt-5'>
                <div className="notify-text-bold text-left pb-1">
                    Assegna le date di inizio e fine conversione a tutte le particelle
                </div>

                <div style={{ display: 'flex', gap: '24px', alignItems: 'flex-end' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className="text-left">
                            <span className="input-label">Data inizio conversione  </span>
                        </div>
                        <Calendar
                            disabled={!parcelState.onEdit}
                            selected={parcelState.startingDateForAll}
                            onChange={(date) => dispatch(setStartingDateForAll(date))}
                            onClear={(date) => dispatch(setStartingDateForAll(date))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className="text-left">
                            <span className="input-label">Data fine conversione  </span>
                        </div>
                        <Calendar
                            disabled={!parcelState.onEdit}
                            selected={parcelState.endingDateForAll}
                            onChange={(date) => dispatch(setEndingDateForAll(date))}
                            onClear={(date) => dispatch(setEndingDateForAll(date))}
                        />
                    </div>
                    <div className='pb-[2px]'>
                        <Button
                            disabled={parcelState.startingDateForAll === undefined && parcelState.endingDateForAll === undefined}
                            variant='solid'
                            color='dimgrey'
                            size='md'
                            iconPosition='off'
                            label='Assegna'
                            onClick={() => dispatch(setAllParcelStartingAndEndingDate({
                                startingDate: parcelState.startingDateForAll,
                                endingDate: parcelState.endingDateForAll
                            }))}
                        />
                    </div>
                </div>
            </div>

            <div>
                <Button
                    variant='solid'
                    color='dimgrey'
                    size='md'
                    iconPosition='off'
                    label='Esporta notifica completa'
                    onClick={() => dispatch(ExportCompleteNotification(notificationState.notificationIdToUpdate))}
                />
            </div>
        </div>
    )
}